import { Component, ElementRef, HostBinding, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation, TemplateRef, HostListener } from '@angular/core';
import { ActivatedRoute, Data, Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil, filter } from 'rxjs/operators';
import { CalsoftMediaWatcherService } from 'src/app/global/services/media-watcher';
import { CalsoftNavigationItem, CalsoftNavigationService } from 'src/app/global/components/navigation';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { map } from 'rxjs/operators';
import { cloneDeep } from 'lodash-es';

import { defaultNavigation } from 'src/app/data/mock/common/navigation/data';
import { CrmsettingsService } from 'src/app/services/crmsettings.service';
import { GeminichatComponent } from 'src/app/geminichat/geminichat.component';
import { MatDialog } from '@angular/material/dialog';
import { HrSettingService } from 'src/app/services/hr-setting.service';
import { environment } from 'src/environments/environment';
import { Constant } from 'src/app/constant/constant';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { ConfigService } from 'src/app/services/config.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HrmUserTimeSummaryService } from 'src/app/services/hrm-user-time-summary.service';
import { GuideService, GuideStep } from 'src/app/services/guide.service';
import { StepGuideService } from 'src/app/services/step-guide.service';
import { CrmSearchComponent } from 'src/app/shared/crm-search/crm-search.component';


@Component({
    selector: 'compact-layout',
    templateUrl: './compact.component.html',
    styleUrls: ['./compact.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CompactLayoutComponent implements OnInit, OnDestroy {

    sanitizedUrl: string = '';

    url = '';

    data: any = { navigation: { compact: [] } };
    isScreenSmall: boolean;

    @HostBinding('class.fixed-header')
    fixedHeader: boolean;

    @HostBinding('class.fixed-footer')
    fixedFooter: boolean;

    // Private
    private _unsubscribeAll: Subject<any>;
    private _matAutocomplete: any;
    appearance: string;
    chatAiType: any = 0;
    crmSettingsData: any;
    hideMenu: boolean;
    hideHeader: boolean;
    currentRouterPath: any;


    @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

    @ViewChild('deviceRestrictionDialog')
    deviceRestrictionDialog!: TemplateRef<any>;

    deviceRestrictionMessage = '';


    savedTours: { id?: number, name: string, videoLink?: string, steps: GuideStep[] }[] = [];
    isShowingTourList = false;
    searchType: string = 'menu';
    displayedTour: boolean = false;

    /**
     * Constructor
     *
     * @param {ActivatedRoute} _activatedRoute
     * @param {CalsoftMediaWatcherService} _calsoftMediaWatcherService
     * @param {CalsoftNavigationService} _calsoftNavigationService
     * @param {Router} _router
     */
    constructor(
        private ecryptService: EcryptServiceService,

        private _activatedRoute: ActivatedRoute,
        private _calsoftMediaWatcherService: CalsoftMediaWatcherService,
        private _calsoftNavigationService: CalsoftNavigationService,
        public _router: Router,
        public dialog: MatDialog,
        private calsoftNavigationService: CalsoftNavigationService,
        public crmsetting: CrmsettingsService,
        private hrSettingService: HrSettingService,
        private configService: ConfigService,
        private hrmUserTimeSummaryService: HrmUserTimeSummaryService,
        private crmsettingsService: CrmsettingsService,
        public guideService: GuideService,

        private snackBar: MatSnackBar,
        private formBuilder: UntypedFormBuilder,
        private stepGuideService: StepGuideService,
    ) {


        // Set the private defaults
        this._unsubscribeAll = new Subject();

        // Set the defaults
        this.fixedHeader = true;
        this.fixedFooter = false;
        this.url = this._router.url || '';
        this.currentRouterPath = this.url;
        this._router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => {
                this.url = this._router.url || '';
                this.currentRouterPath = this.url;
            });

        this.url = this._router.url || '';
        this.currentRouterPath = this.url;
        this.sanitizedUrl = this.sanitizeUrl(this.url);
        this._router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => {
                this.url = this._router.url || '';
                this.currentRouterPath = this.url;
                this.sanitizedUrl = this.sanitizeUrl(this.url);
                this.close();
            });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    private readonly _defaultNavigation: CalsoftNavigationItem[] = defaultNavigation;

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    @Input() debounce: number = 300;

    @Input() minLength: number = 2;
    /**
     * On init
     */


    statuses: string[] = ['Online', 'Offline', 'Break'];
    currentStatus: string = 'Offline';

    startTime: number | null = null;
    elapsedTime: number = 0;
    totalOnlineTime: number = 0;
    totalBreakTime: number = 0;
    totalOfflineTime: number = 0;
    currentISTTime: string = '';
    currentISTDateTime: string = '';

    timerInterval: any;
    isVisibleSearch: boolean = true;

    path: string;

    public serverPath = environment.commonImageApi + "/sitelogo/";
    intervalId: any;
    posEnabled: any = 0;
    tourNavigateEnable: any;
    ngOnInit() {
        this.loadSavedTours();
        this.getConfig();
        this.checkLocalStorage();
        this.intervalId = setInterval(() => this.checkLocalStorage(), 500); // check every 500ms
        this.generalHrmUserTimeSummaryForm();

        //this.path = this.serverPath + "logo.png";
        let aiEnabled: any;
        let aiType: any;

        this.displayedTour = localStorage.getItem('displayedTour') == 'true';

        const encrypted = localStorage.getItem('crmSettingsData');
        if (encrypted) {
            try {
                const decrypted = this.ecryptService.decryptionAES(encrypted);
                this.crmSettingsData = JSON.parse(decrypted);
                aiEnabled = this.crmSettingsData.aiEnabled;
                aiType = this.crmSettingsData.aiType;
                this.tourNavigateEnable = this.crmSettingsData.tourNavigateEnable;

            } catch (err) {
                console.error("Error decrypting crmSettingsData", err);
            }
        }

        this.getAllhrmSettings();

        this.getConfigData();



        if (aiEnabled != undefined) {
            this.chatAiEnable = aiEnabled;

        }

        if (aiEnabled != undefined) {
            this.chatAiType = aiType;

        }


        // Subscribe to the resolved route data
        this._activatedRoute.data.subscribe((data: Data) => {
            this.data = data.initialData;

        });

        // Subscribe to media changes
        this._calsoftMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {

                // Check if the breakpoint is 'lt-md'
                this.isScreenSmall = matchingAliases.includes('lt-md');
            });




        this.searchControl.valueChanges
            .pipe(
                debounceTime(this.debounce),
                takeUntil(this._unsubscribeAll),
                map((value) => {


                    // Set the resultSets to null if there is no value or
                    // the length of the value is smaller than the minLength
                    // so the autocomplete panel can be closed
                    if (!value || value.length < this.minLength) {
                        this.resultSets = null;
                    }

                    // Continue
                    return value;
                }),
                // Filter out undefined/null/false statements and also
                // filter out the values that are smaller than minLength
                filter(value => value && value['length'] >= this.minLength)
            )
            .subscribe((value) => {

                this.resultSets = []
                if (value === '') {
                    return this.resultSets = [];
                }
                // Filter the navigation

                if (!this.data?.navigation?.compact?.[0]?.[0]?.search) {
                    return this.resultSets = [];
                }

                const flatNavigation = JSON.parse(this.data.navigation.compact[0][0].search);
                const clean = (s: string) => s ? s.toLowerCase().replace(/[\s\/\-_]+/g, '') : '';
                const valLower = value.toLowerCase();
                const valClean = clean(value);

                const pagesResults = cloneDeep(flatNavigation)
                    .filter(page => {
                        if (!page.link) return false;

                        const titleMatch = page.title && (page.title.toLowerCase().includes(valLower) || clean(page.title).includes(valClean));
                        const defaultNameMatch = page.defaultName && (page.defaultName.toLowerCase().includes(valLower) || clean(page.defaultName).includes(valClean));
                        const linkMatch = page.link && (page.link.toLowerCase().includes(valLower) || clean(page.link).includes(valClean));
                        const nameMatch = page.name && (page.name.toLowerCase().includes(valLower) || clean(page.name).includes(valClean));

                        return titleMatch || defaultNameMatch || linkMatch || nameMatch;
                    });

                if (pagesResults.length > 0) {
                    this.resultSets.push({
                        id: 'pages',
                        label: 'Pages',
                        results: pagesResults
                    });


                } else {
                    this.resultSets = []
                }

            });


        const storedTotalOnlineTime = localStorage.getItem('totalOnlineTime');
        const storedTotalBreakTime = localStorage.getItem('totalBreakTime');
        const storedTotalOfflineTime = localStorage.getItem('totalOfflineTime');
        const storedStatus = localStorage.getItem('currentStatus');

        if (storedTotalOnlineTime) {
            this.totalOnlineTime = parseInt(storedTotalOnlineTime, 10);
        }
        if (storedTotalBreakTime) {
            this.totalBreakTime = parseInt(storedTotalBreakTime, 10);
        }
        if (storedTotalOfflineTime) {
            this.totalOfflineTime = parseInt(storedTotalOfflineTime, 10);
        }

        if (storedStatus) {
            this.currentStatus = storedStatus;
        }

        this.getCurrentIST();
        setInterval(() => {
            this.getCurrentIST();
        }, 1000);

        if (this.currentStatus === 'Online' || this.currentStatus === 'Break' || this.currentStatus === 'Offline') {
            this.startTime = Date.now();
            this.elapsedTime = 0;
            this.startTimer();
        }

        // Handle recording finish from any component (e.g. StepGuideComponent overlay)
        this.guideService.recordingFinished$.pipe(
            takeUntil(this._unsubscribeAll)
        ).subscribe(steps => {
            this.handleRecordingFinished(steps);
        });

        // Handle device restriction alerts from GuideService
        this.guideService.deviceRestriction$.pipe(
            takeUntil(this._unsubscribeAll)
        ).subscribe(message => {
            this.openDeviceRestrictionPopup(message);
        });
    }
    handleRecordingFinished(steps: GuideStep[]) {

        if (!steps || steps.length === 0) {
            this.snackBar.open('No steps recorded. Tour discarded.', '×', {
                panelClass: 'success',
                verticalPosition: 'bottom',
                duration: 500
            });
            return;
        }

        const name = prompt(
            'Enter a name for this product tour:',
            `Tour ${this.savedTours.length + 1}`
        );

        if (name) {

            // Device Type
            const deviceType = window.innerWidth <= 768 ? 2 : 1;

            const newTour = {
                stepTitle: name,
                isActive: 1,
                operationType: 'New',
                deviceType: deviceType, // Added here
                stepGuideSteps: steps.map((s, index) => ({
                    stepKey: s.id,
                    stepOrder: index + 1,
                    text: s.text,
                    route: s.route,
                    action: s.action,
                    overlayContext: s.overlayContext,
                    manual: s.manual ? 1 : 0,
                    guideId: s.guideId
                        ? parseInt(s.guideId.replace(/\D/g, '')) || null
                        : null,
                    guideKey: s.guideKey
                        ? parseInt(s.guideKey.replace(/\D/g, '')) || null
                        : null,
                    selector: s.selector,
                    matchIndex: s.matchIndex || 0,
                    stepSescription: s.description || 'Auto-recorded step',
                    imageUrl: s.imageUrl,
                    imageLinkUrl: s.imageLinkUrl,
                    customfield1: s.customfield1,
                    customfield3: s.customfield3 || '1',
                    isActive: 1
                }))
            };

            this.stepGuideService.addOrEditStepGuide(newTour).subscribe(
                (res: any) => {
                    this.snackBar.open(
                        res['status_message'] || 'Tour saved successfully!',
                        '×',
                        {
                            panelClass: 'success',
                            verticalPosition: 'bottom',
                            duration: 500
                        }
                    );
                    this.loadSavedTours();
                },
                (err) => {
                    this.snackBar.open('Error saving tour', '×', {
                        panelClass: 'error',
                        verticalPosition: 'bottom',
                        duration: 500
                    });
                }
            );
        }
    }

    checkLocalStorage() {
        const hideMain = localStorage.getItem('HideMainMenu');
        const subscriptionExpired = localStorage.getItem('SubscriptionExpired');
        this.hideMenu = hideMain === 'true' || subscriptionExpired === 'true';
        this.displayedTour = localStorage.getItem('displayedTour') == 'true';
    }


    getConfigData() {
        this.configService.getConfigDataNew()
            .subscribe(
                (response: any) => {


                    let configData = response;

                    let config = response;

                    if (response.encryptedText != null) {
                        const decrypted = this.ecryptService.decryptionAES(response.encryptedText);
                        configData = JSON.parse(decrypted);
                    }


                    // Don't overwrite this.data which contains navigation data


                    if (configData != null) {
                        this.posEnabled = configData['posEnabled'];
                    } else {
                        this.posEnabled = 0;
                    }

                }, error => {

                }
            );
    }

    enableOnline: any = 0;

    getAllhrmSettings() {

        this.hrSettingService.getHrSettingsData().subscribe(
            data => {

                if (data != null) {
                    this.enableOnline = data['enableOnline'];

                } else {
                    this.enableOnline = 0;
                }


            },
            error => {

            }
        )
    }

    startTimer(): void {
        if (!this.timerInterval) {
            this.timerInterval = setInterval(() => {
                if (this.startTime) {
                    this.elapsedTime = Date.now() - this.startTime;
                }
            }, 1000);
        }
    }

    // onStatusChange(): void {
    //   const currentTime = Date.now();

    //   if (this.currentStatus === 'Online') {
    //     if (this.startTime) {
    //       this.elapsedTime = currentTime - this.startTime;
    //       this.totalOnlineTime += this.elapsedTime;
    //       localStorage.setItem('totalOnlineTime', this.totalOnlineTime.toString());
    //     }
    //   }

    //   if (this.currentStatus === 'Break' || this.currentStatus === 'Offline') {
    //     clearInterval(this.timerInterval);
    //     this.timerInterval = null;

    //     if (this.startTime) {
    //       this.elapsedTime = currentTime - this.startTime;
    //       this.totalOnlineTime += this.elapsedTime;
    //       localStorage.setItem('totalWorkingTime', this.totalOnlineTime.toString());
    //     }
    //   }

    //   if (this.currentStatus === 'Online') {
    //     this.startTime = Date.now();
    //     this.startTimer();
    //   } else {
    //     this.startTime = null;
    //   }

    //   localStorage.setItem('WorkingcurrentStatus', this.currentStatus);
    // }

    firstFormGroup: UntypedFormGroup;


    generalHrmUserTimeSummaryForm() {
        this.firstFormGroup = this.formBuilder.group({
            id: [0],
            userId: [''],
            trackingDate: [''],
            onlineStartTime: [''],
            onlineEndTime: [''],
            onlineTotalDuration: [''],
            breakStartTime: [''],
            breakEndTime: [''],
            breakTotalDuration: [''],
            offlineStartTime: [''],
            offlineEndTime: [''],
            offlineTotalDuration: [''],
            createdBy: [''],
            updatedBy: [''],
        },
        );
    }




    onStatusChange(): void {
        const currentTime = Date.now();
        const previousStatus = localStorage.getItem('currentStatus');

        if (this.startTime !== null && previousStatus) {
            this.elapsedTime = currentTime - this.startTime;

            if (previousStatus === 'Online') {
                this.totalOnlineTime += this.elapsedTime;
                this.firstFormGroup.patchValue({
                    onlineEndTime: this.getCurrentIST()
                });
                localStorage.setItem('totalOnlineTime', this.totalOnlineTime.toString());
            } else if (previousStatus === 'Break') {
                this.totalBreakTime += this.elapsedTime;
                this.firstFormGroup.patchValue({
                    breakEndTime: this.getCurrentIST()
                });
                localStorage.setItem('totalBreakTime', this.totalBreakTime.toString());
            } else if (previousStatus === 'Offline') {
                this.totalOfflineTime += this.elapsedTime;
                this.firstFormGroup.patchValue({
                    offlineEndTime: this.getCurrentIST()
                });
                localStorage.setItem('totalOfflineTime', this.totalOfflineTime.toString());
            }
        }

        this.firstFormGroup.patchValue({
            trackingDate: this.getCurrentIST().split(' ')[0],
            onlineTotalDuration: this.formatDuration(this.totalOnlineTime),
            breakTotalDuration: this.formatDuration(this.totalBreakTime),
            offlineTotalDuration: this.formatDuration(this.totalOfflineTime)
        });

        clearInterval(this.timerInterval);
        this.timerInterval = null;
        this.startTime = Date.now();
        this.elapsedTime = 0;
        const now = this.getCurrentIST();

        if (this.currentStatus === 'Online') {
            this.firstFormGroup.patchValue({ onlineStartTime: now });
        } else if (this.currentStatus === 'Break') {
            this.firstFormGroup.patchValue({ breakStartTime: now });
        } else if (this.currentStatus === 'Offline') {
            this.firstFormGroup.patchValue({ offlineStartTime: now });
        }
        localStorage.setItem('currentStatus', this.currentStatus);
        this.startTimer();
        this.saveHrSetting();
    }

    saveHrSetting() {
        if (this.firstFormGroup.valid) {
            this.hrmUserTimeSummaryService.addOrEditHrmUserTimeSummary(this.firstFormGroup.value).subscribe(
                (response) => {
                    if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
                        this.snackBar.open(response['status_message'], '×', {
                            panelClass: 'success',
                            verticalPosition: 'bottom',
                            duration: 300
                        });
                    } else {
                        this.snackBar.open(response['status_message'], '×', {
                            panelClass: 'error',
                            verticalPosition: 'bottom',
                            duration: 300
                        });
                    }
                },
                (err) => { }
            );
        } else {
            this.firstFormGroup.markAllAsTouched();
        }
    }

    formatDuration(ms: number): string {
        const totalSeconds = Math.floor(ms / 1000);
        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    }


    getCurrentIST(): string {
        const now = new Date();
        const istTime = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));

        const year = istTime.getFullYear();
        const month = String(istTime.getMonth() + 1).padStart(2, '0');
        const day = String(istTime.getDate()).padStart(2, '0');
        const hours = String(istTime.getHours()).padStart(2, '0');
        const minutes = String(istTime.getMinutes()).padStart(2, '0');
        const seconds = String(istTime.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    chatAiEnable: any = 0;
    crmType: any = 0;

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();

        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
        if (this.intervalId) clearInterval(this.intervalId);
        this._onDestroy.next();
        this._onDestroy.complete();
    }



    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param key
     */
    toggleNavigation(key: string): void {
        const tourStatus = localStorage.getItem("TourEnables");
        if (tourStatus === "0") {
            console.warn("Navigation disabled during tour");
            return;
        }
        const navigation = this._calsoftNavigationService.getComponent(key);

        if (navigation) {
            navigation.toggle();
        }
    }


    // search 

    opened: boolean = false;
    searchControl: UntypedFormControl = new UntypedFormControl();
    resultSets: any = []
    resultSets1: any[] = [{
        "id": "pages",
        "label": "Pages",
        "results": [{
            "id": "apps.contacts",
            "title": "Contacts",
            "type": "basic",
            "icon": "heroicons_outline:user-group",
            "link": "/apps/contacts",
            "value": "Contacts"
        },
        {
            "id": "user-interface.confirmation-dialog",
            "title": "Confirmation Dialog",
            "type": "basic",
            "icon": "heroicons_outline:question-mark-circle",
            "link": "/ui/confirmation-dialog",
            "value": "Confirmation Dialog"
        }
        ]
    }];

    open(): void {
        // Return if it's already opened
        if (this.opened) {
            return;
        }

        setTimeout(() => {
            this.searchInput.nativeElement.focus();
        });

        // Open the search
        this.opened = true;
    }

    close(): void {
        // Return if it's already closed
        if (!this.opened) {
            return;
        }

        // Clear the search input
        this.searchControl.setValue('');

        // Close the search
        this.opened = false;
    }

    trackByFn(index: number, item: any): any {
        return item.id || index;
    }


    onKeydown(event: KeyboardEvent): void {
        // Escape
        if (event.code === 'Escape') {
            // If the appearance is 'bar' and the mat-autocomplete is not open, close the search
            if (this.appearance === 'bar' && !this._matAutocomplete.isOpen) {
                this.close();
            }
        }
    }

    getToRoute(link: any) {
        if (!link) return;
        this.close();
        const targetUrl = link.startsWith('/') ? link : '/' + link;
        this._router.navigateByUrl(targetUrl);
    }

    config: any;

    chromeExtensionId: string;

    getConfig() {
        this.configService.getConfigDataNew().subscribe(
            (response: any) => {


                let configData = response;

                let config = response;

                if (response.encryptedText != null) {
                    const decrypted = this.ecryptService.decryptionAES(response.encryptedText);
                    configData = JSON.parse(decrypted);
                }


                this.config = configData;

                this.chromeExtensionId = this.config.chromeExtensionId;

                this.detectExtension();
            },
            (err) => {
                console.error('Error fetching POS config:', err);
            }
        );
    }



    openChatDialog() {
        const dialogRef = this.dialog.open(GeminichatComponent, {
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            maxHeight: '100vh',
            panelClass: 'full-screen-dialog'
        });
    }
    async detectExtension() {
        const extensionId = this.chromeExtensionId;
        return new Promise<string | null>((resolve) => {
            if (!window['chrome']?.runtime) return resolve(null);

            window['chrome'].runtime.sendMessage(extensionId, { type: 'GET_CLIENT_ID' }, (response) => {
                if (window['chrome'].runtime.lastError) {
                    console.log('Extension not found or message failed:', window['chrome'].runtime.lastError.message);
                    return;
                }
                console.log('Response from extension:', response.clientId);
                if (response.clientId) {
                    this.configService.setClientID({ clientId: response.clientId }).subscribe({
                        next: (res) => console.log('Client ID set successfully', res),
                        error: (err) => console.error('Error setting client ID', err)
                    });
                }
            });
        })
    }


    explore() {
        this._router.navigate(['/marketplace']);
    }

    loadSavedTours() {
        this.stepGuideService.getAllStepGuideDropDown().subscribe(
            (res: any) => {
                if (res && res.length > 0) {
                    this.savedTours = res.map((item: any) => ({
                        id: item.id,
                        name: item.stepTitle,
                        deviceType: item.deviceType,
                        videoLink: item.videoLink,
                        steps: (item.stepGuideSteps || []).sort((a, b) => a.stepOrder - b.stepOrder).map((s: any) => ({
                            id: s.stepKey,
                            text: s.text,
                            route: s.route,
                            action: s.action,
                            overlayContext: s.overlayContext,
                            manual: s.manual === 1,
                            guideId: s.guideId ? s.guideId.toString() : null,
                            guideKey: s.guideKey ? s.guideKey.toString() : null,
                            selector: s.selector,
                            matchIndex: s.matchIndex,
                            description: s.stepSescription,
                            imageUrl: s.imageUrl,
                            imageLinkUrl: s.imageLinkUrl,
                            customfield1: s.customfield1,
                            customfield3: s.customfield3,
                            videoLink: s.videoLink
                        }))
                    }));
                } else {
                    this.savedTours = [];
                }
            },
            (err) => {
                // Ignore gracefully for lack of error handling
                this.savedTours = [];
            }
        );
    }

    toggleRecording() {
        if (this.guideService.isRecording) {
            this.guideService.stopRecording();
            this.snackBar.open('Recording stopped.', '×', {
                panelClass: 'success',
                verticalPosition: 'bottom',
                duration: 500
            });
        } else {

            console.log("tourNavigateEnable", this.tourNavigateEnable);


            this.guideService.startRecording(this.tourNavigateEnable);
            this.snackBar.open('Recording started. Click on any UI elements to add steps.', '×', {
                panelClass: 'success',
                verticalPosition: 'bottom',
                duration: 500
            });
        }
    }

    playTour(tour: any) {
        const steps = tour.steps;
        if (steps) {
            (steps as any).deviceType = tour.deviceType;
        }
        this.guideService.start(steps, [], tour.videoLink);
        this.isShowingTourList = false;
    }

    openDeviceRestrictionPopup(message: string): void {
        this.deviceRestrictionMessage = message;
        this.dialog.open(this.deviceRestrictionDialog, {
            width: '400px',
            disableClose: true
        });
    }

    deleteTour(tourIndex: number) {
        if (confirm('Are you sure you want to delete this tour?')) {
            const tourToDelete: any = this.savedTours[tourIndex];

            if (tourToDelete && tourToDelete.id) {
                this.stepGuideService.deleteByStepGuideId(tourToDelete.id).subscribe(
                    (res: any) => {
                        this.savedTours.splice(tourIndex, 1);
                        this.snackBar.open(res['status_message'] || 'Tour deleted successfully!', '×', {
                            panelClass: 'success',
                            verticalPosition: 'bottom',
                            duration: 500
                        });
                    },
                    (err) => {
                        this.snackBar.open('Error deleting tour', '×', {
                            panelClass: 'error',
                            verticalPosition: 'bottom',
                            duration: 500
                        });
                    }
                );
            } else {
                this.savedTours.splice(tourIndex, 1);
            }
        }
    }

    sanitizeUrl(u: string): string {
        return (u || '')
            .replace(/^\/+/, '')
            .replace(/[?#&=]/g, '-')
            .replace(/[^a-zA-Z0-9_-]+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '')
            .toLowerCase();
    }

    goToPopUp() {
        if (window.innerWidth > 768) {
            const dialogRef = this.dialog.open(CrmSearchComponent, {
                width: '80%',
                maxWidth: '1200px',
                height: '100%',
                data: {

                },
                position: { right: '0' },
                panelClass: 'slide-dialog-panel',
                hasBackdrop: true,
                disableClose: false
            });
        } else {
            const dialogRef = this.dialog.open(CrmSearchComponent, {
                minWidth: '100vw', height: '100vh',
                data: {

                },
                position: { right: '0' },
                panelClass: 'slide-dialog-panel',
                hasBackdrop: true,
                disableClose: false
            });
        }
    }

    onSearchTypeChange() {
        if (this.searchType === 'crm') {
            this.goToPopUp();
            // Reset to menu so the selection is ready for next time
            setTimeout(() => {
                this.searchType = 'menu';
            }, 100);
        } else if (this.searchType === 'menu') {
            this.open();
        }
    }

    protected _onDestroy = new Subject<void>();


    // get currentPageName(): string {
    //     return this.currentRouterPath
    //         ?.replace(/^\/+/, '')          // remove starting /
    //         .split('/')
    //         .pop()                         // take last route segment
    //         ?.replace(/-/g, ' ')          // replace - with space
    //         ?.replace(/\b\w/g, c => c.toUpperCase()) || 'Dashboard';
    // }




}
